import axiosInstance from "../axiosInstance";
import { endpoints } from "../endpoints";

export const createLink = async (body) => {
  //   console.warn("update video", body, endpoints.video.update);
  const res = await axiosInstance.post(endpoints.link.create, body);
  return res.data;
};
